import { Component, Input } from '@angular/core';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-number-filter',
  standalone: true,
  templateUrl: './number-filter.component.html',
  imports: [MatLabel, MatFormField, MatInput, ReactiveFormsModule, MatSuffix, MatError],
  styleUrl: './number-filter.component.scss'
})
export class NumberFilterComponent {
  @Input() paramsGroup!: FormGroup;
}
